<p-panel header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary' | hisUi}}">

    <div class="layoutBlock">
        <div class="columnFull">
            <button type="text" hisImage="plus_circ_green" class="transparent" (click)="openInputDialog()">
                <span>{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.button.addTravelItinerary'
                    |
                    hisUi}}</span>
            </button>
            <button [disabled]='isDeleteAllButtonDisabled' type="text" hisImage="stop_cross" class="transparent"
                (click)="deleteAllTravelitinerary()">
                <span>{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.button.deleteAllTravelItinerary'
                    | hisUi}}</span>
            </button>
        </div>
        <div class="clearAndSpace"></div>

        <!-- Listview of travelitinerarys -->
        <ng-container *ngFor="let travelitinerary of listTravelitinerary; let i = index">
            <div class="columnHalf">
                <div class="layoutBlock">
                    <div class="listviewBadgeLeft">
                        <div class="circleIconContainer">
                            <div class="circle-icon">
                                <div><img hisImage="milestone" class="inlineicon"
                                        title="{{'rm.erp.travelmanagement.businesstripapplication.icon.travelSection' | hisUi}}">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="listviewSideRight">
                        <h2>{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.listTravelItinerary'
                            | hisUi}}
                            ({{i+1}})</h2>
                        <ul class="listSimple">
                            <li>
                                <div *ngIf="travelitinerary.tripBeginDate" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.tripBeginDate'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{travelitinerary.tripBeginDate | hisDate:
                                        dateTimeFormat}}</div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="travelitinerary.tripEndDate" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.tripEndDate'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{travelitinerary.tripEndDate | hisDate:
                                        dateTimeFormat}}</div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="travelitinerary.origin" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.arrivalFrom'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{travelitinerary.origin}}</div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="travelitinerary.arrivalSelected" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.arrival'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{travelitinerary.arrivalSelected.text}}</div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="travelitinerary.destination" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.returnTripFrom'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{travelitinerary.destination}}</div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="travelitinerary.returnTripSelected" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.returnTrip'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{travelitinerary.returnTripSelected.text}}</div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="travelitinerary.transportationSelected" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.meansOfTransport'
                                        | hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{travelitinerary.transportationSelected.text}}</div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="travelitinerary.distance" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.distance'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{travelitinerary.distance}}</div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="travelitinerary.emissions" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.emissions'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{travelitinerary.emissions}}</div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="travelitinerary.compensationAmount" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.compensationAmount'
                                        | hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{travelitinerary.compensationAmount}}</div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="travelitinerary.travelZoneSelected" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.travelZone'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{travelitinerary.travelZoneSelected.text}}</div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="travelitinerary.reason" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.reason'
                                        | hisUi}}
                                    </div>
                                    <div class="textWrapTwoColumn">{{travelitinerary.reason}}</div>
                                </div>
                            </li>
                        </ul>

                        <button type="text" hisImage="pencil" class="transparent"
                            (click)="editTravelitinerary(i)">{{'common.edit' | hisUi}}</button>
                        <button type="text" hisImage="delete" class="transparent"
                            (click)="deleteTravelitinerary(i)">{{'common.delete' | hisUi}}</button>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</p-panel>

<!-- Inputdialog for creating or editing travelitinerary -->
<ng-template #newOrEditTravelitineraryDialogContainer [ngIf]="isInputDialogVisible">
    <div>
        <p-dialog [(visible)]="isInputDialogVisible" height="auto" [draggable]="false" [responsive]="true"
            [modal]="true" [dismissableMask]="true" [blockScroll]="true">
            <p-header>
                <h2 *ngIf="travelItineraryWithPosition.isNewElement else editTextTravelitinerary">
                    {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.addTravelItinerary'
                    |
                    hisUi}}</h2>
                <ng-template #editTextTravelitinerary>
                    <h2>{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.editTravelItinerary'
                        | hisUi}}</h2>
                </ng-template>
            </p-header>

            <his-plam>
                <p-calendar #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.tripBeginDate"
                    [(ngModel)]="travelItineraryWithPosition.travelItinerary.tripBeginDate"
                    [dateFormat]="dateTimeFormat" [showTime]="true" styleClass="calendarWidth100"
                    [monthNavigator]="true" [yearNavigator]="true" [placeholder]="dateTimePlaceholderFormat">
                </p-calendar>
            </his-plam>

            <his-plam>
                <p-calendar #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.tripEndDate"
                    [(ngModel)]="travelItineraryWithPosition.travelItinerary.tripEndDate" [dateFormat]="dateTimeFormat"
                    [showTime]="true" styleClass="calendarWidth100" [monthNavigator]="true" [yearNavigator]="true"
                    [placeholder]="dateTimePlaceholderFormat">
                </p-calendar>
            </his-plam>

            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.arrival"
                    field="text" [(ngModel)]="travelItineraryWithPosition.travelItinerary.arrivalSelected"
                    hisEagerDataSource="{{'api/v1/rm/erp/travelmanagement/values/erparrival'}}?filter_validon={{currentDate}}"
                    [forceSelection]="true">
                </p-autoComplete>
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.arrivalFrom"
                    class="inputWidth100" [(ngModel)]="travelItineraryWithPosition.travelItinerary.origin">
            </his-plam>

            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.returnTrip"
                    field="text" [(ngModel)]="travelItineraryWithPosition.travelItinerary.returnTripSelected"
                    hisEagerDataSource="{{'api/v1/rm/erp/travelmanagement/values/erpreturntrip'}}?filter_validon={{currentDate}}"
                    [forceSelection]="true">
                </p-autoComplete>
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.returnTripFrom"
                    class="inputWidth100" [(ngModel)]="travelItineraryWithPosition.travelItinerary.destination">
            </his-plam>

            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.meansOfTransport"
                    field="text" [(ngModel)]="travelItineraryWithPosition.travelItinerary.transportationSelected"
                    hisEagerDataSource="{{'api/v1/rm/erp/travelmanagement/values/erptransportation'}}?filter_validon={{currentDate}}"
                    [forceSelection]="true">
                </p-autoComplete>
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.distance"
                    class="inputWidth100" [(ngModel)]="travelItineraryWithPosition.travelItinerary.distance">
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.emissions"
                    class="inputWidth100" [(ngModel)]="travelItineraryWithPosition.travelItinerary.emissions">
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.compensationAmount"
                    class="inputWidth100" [(ngModel)]="travelItineraryWithPosition.travelItinerary.compensationAmount">
            </his-plam>

            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.travelZone"
                    field="text" [(ngModel)]="travelItineraryWithPosition.travelItinerary.travelZoneSelected"
                    hisEagerDataSource="{{'api/v1/rm/erp/travelmanagement/values/erptravelzone'}}?filter_validon={{currentDate}}"
                    [forceSelection]="true">
                </p-autoComplete>
            </his-plam>

            <his-plam>
                <textarea #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary.reason"
                    class="textareaWidth100 expand" rows="1"
                    [(ngModel)]="travelItineraryWithPosition.travelItinerary.reason"></textarea>
            </his-plam>

            <button (click)="addTravelItineraryAndCloseInputDialog()"><span>{{ 'common.apply' | hisUi }}</span></button>
            <button (click)="closeInputDialog()"><span>{{ 'common.cancel' | hisUi }}</span></button>

        </p-dialog>
    </div>
</ng-template>